import EntityBaseRepository from '@/api/misc/EntityBaseRepository';
import { AxiosResponse } from 'axios';
import Promoter from '@/models/Promoter';

export default class PromoterRepository extends EntityBaseRepository {
    public list(payload: {from: string, to: string}): Promise<AxiosResponse> {
        return this.axiosClient.get(`promoter?from=${payload.from}&to=${payload.to}`);
    }

    public create(payload: Promoter): Promise<AxiosResponse> {
        return this.axiosClient.post('promoter', payload);
    }

    public update(payload: Promoter): Promise<AxiosResponse> {
        return this.axiosClient.patch(`promoter/${payload.id}`, payload);
    }

    public delete(id: string): Promise<AxiosResponse> {
        return this.axiosClient.delete(`promoter/${id}`);
    }

    public getStatistics(id: string): Promise<AxiosResponse> {
        return this.axiosClient.get(`promoter/${id}/statistics`);
    }

    public getPayouts(payload: { from: string, to: string }): Promise<AxiosResponse> {
        return this.axiosClient.get(`promoter/payouts?from=${payload.from}&to=${payload.to}`);
    }

    public markPaid(payload: {
        id: string, amount: number, period: string, from: string, to: string
    }): Promise<AxiosResponse> {
        return this.axiosClient.post(`promoter/${payload.id}/mark-paid`, {
            amount: payload.amount,
            period: payload.period,
            from: payload.from,
            to: payload.to
        });
    }

    /**
     * Works out what moving a driver to another promoter would cost, without
     * changing anything. The returned planHash has to be handed back to
     * applyReassignment so the amounts that get written are the ones that were
     * shown.
     */
    public previewReassignment(payload: { driver: string, toPromoter: string }): Promise<AxiosResponse> {
        return this.axiosClient.post('promoter/reassignment/preview', payload);
    }

    public applyReassignment(payload: {
        driver: string, toPromoter: string, planHash: string
    }): Promise<AxiosResponse> {
        return this.axiosClient.post('promoter/reassignment/apply', payload);
    }
}
